export default __webpack_public_path__ + "static/media/iPurvery Logo PNG.01a74718.svg";